
import React, { useEffect } from 'react';
import { useThemeController } from '@/hooks/useThemeController';

const ThemeInitializer: React.FC = () => {
  const { mounted } = useThemeController();
  
  // This component just needs to exist to trigger the theme system
  // The useThemeController hook handles all the initialization
  useEffect(() => {
    if (mounted) {
      console.log('Theme system initialized');
    }
  }, [mounted]);

  return null; // This component doesn't render anything
};

export default ThemeInitializer;
